import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { TabsContent } from "@/components/ui/tabs";
import { UseFormReturn } from "react-hook-form";
import { AccessLevelFormValues } from "./form";
import { Textarea } from "@/components/ui/textarea";

interface AccessLevelDataTabProps {
  form: UseFormReturn<AccessLevelFormValues>;
}

const AccessLevelDataTab = ({ form }: AccessLevelDataTabProps) => {
  return (
    <TabsContent value="access_level_data" className="space-y-6 mt-4">
      <FormField
        control={form.control}
        name="access_level_data.name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Nome do perfil</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="access_level_data.description"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Descrição</FormLabel>
            <FormControl>
              <Textarea {...field} value={field.value ?? ""} rows={3} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="access_level_data.is_default"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
            <div
              className="space-y-0.5 hover:cursor-pointer"
              onClick={() => field.onChange(!field.value)}
            >
              <FormLabel
                className="text-base hover:cursor-pointer"
                htmlFor="is_default"
              >
                Padrão para novos usuários
              </FormLabel>
              <FormDescription>
                Se marcado, novos usuários criados assumirão este perfil
                automaticamente.
              </FormDescription>
            </div>
            <FormControl>
              <Switch
                className="bg-primary-500"
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </TabsContent>
  );
};

export default AccessLevelDataTab;
